import { EcaApiGateway } from './api-gateway';
import { EcaEnvironmentService } from './../environment/environment.service';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EcaApiGatewayService {
  private _ecaEnvironmentService = inject(EcaEnvironmentService);


  lookup(serviceName: string, options: any = {}) {
    return EcaApiGateway.lookup(this._ecaEnvironmentService.json, serviceName, options);
  }
}
